import { useMutation } from '@tanstack/react-query';
import { adminServices } from '../../../Domain/Admin/Services';

const mutationFn = (data: File) => {
  return adminServices.uploadNaverrekenenTemplate(data);
};

export const useUploadNaverrekenenTemplateMutation = () => {
  return useMutation<unknown, unknown, File>(mutationFn);
};
